<template>
    <div class="w1200 audition-page" v-loading="loading">
        <div class="audition-type">
            <div class="desc">海选结果 · {{ result ? result.periodName : '' }}</div>
            <div class="actions">
                <el-input
                    v-model="inputPeriodId"
                    size="small"
                    placeholder="输入期次ID查询历史"
                    style="width:160px"
                    @keyup.enter.native="loadByInput" />
                <el-button type="primary" size="small" @click="loadByInput">查询</el-button>
                <span class="apply_sss" @click="goBack">返回栏目</span>
            </div>
        </div>

        <div v-if="!loading && !result" style="text-align:center;padding:60px;color:#999;">
            暂无结果数据。开奖结算后可查看命中与积分排行。
        </div>

        <template v-if="result">
            <div class="audition-table">
                <div class="head"><div class="tit">冠亚季军</div></div>
                <el-table
                    :data="result.topThree || []"
                    :border="true"
                    style="width:100%"
                    :header-cell-style="{ background: '#347CAF', color: '#fff' }">
                    <el-table-column label="名次" width="80">
                        <template slot-scope="{ $index, row }">
                            <span v-if="$index <= 2" class="rank-img">
                                <img :src="require(`@/assets/common/rank/${$index + 1}.gif`)" alt="">
                            </span>
                            <span v-else>{{ row.finalRank || ($index + 1) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="方案名称">
                        <template slot-scope="{ row }">
                            <span>{{ row.title }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创作者" prop="userName" width="140" />
                    <el-table-column label="本期命中" width="100">
                        <template slot-scope="{ row }">{{ row.redHitCount != null ? row.redHitCount + ' 个' : '-' }}</template>
                    </el-table-column>
                    <el-table-column label="本期积分" width="100">
                        <template slot-scope="{ row }">{{ formatScore(row.periodScore) }}</template>
                    </el-table-column>
                    <el-table-column label="往期累计" width="100">
                        <template slot-scope="{ row }">{{ formatScore(row.totalScore) }}</template>
                    </el-table-column>
                    <el-table-column label="荣誉" prop="badge" width="140" />
                    <el-table-column label="操作" width="80" align="center">
                        <template slot-scope="{ row }">
                            <el-button type="text" size="small" class="title-link" @click.stop="goDetail(row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="audition-table" style="margin-top:24px;">
                <div class="head"><div class="tit">前十榜单</div></div>
                <el-table
                    :data="result.topTen || []"
                    :border="true"
                    style="width:100%"
                    :header-cell-style="{ background: '#347CAF', color: '#fff' }">
                    <el-table-column label="名次" width="80">
                        <template slot-scope="{ row }">{{ row.finalRank || '-' }}</template>
                    </el-table-column>
                    <el-table-column label="方案名称">
                        <template slot-scope="{ row }">
                            <span>{{ row.title }}</span>
                            <span v-if="row.isTop === 1" class="entry-badge top">置顶</span>
                            <span v-if="row.isFeatured === 1" class="entry-badge featured">加精</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创作者" prop="userName" width="140" />
                    <el-table-column label="本期命中" width="100">
                        <template slot-scope="{ row }">{{ row.redHitCount != null ? row.redHitCount + ' 个' : '-' }}</template>
                    </el-table-column>
                    <el-table-column label="本期积分" width="100">
                        <template slot-scope="{ row }">{{ formatScore(row.periodScore) }}</template>
                    </el-table-column>
                    <el-table-column label="往期累计" width="100">
                        <template slot-scope="{ row }">{{ formatScore(row.totalScore) }}</template>
                    </el-table-column>
                    <el-table-column label="荣誉" prop="badge" width="140" />
                    <el-table-column label="操作" width="80" align="center">
                        <template slot-scope="{ row }">
                            <el-button type="text" size="small" class="title-link" @click.stop="goDetail(row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>
    </div>
</template>

<script>
import { getLatestPeriod, getResult, getChampionTopic } from '@/api/audition'
import { ALLOWED_PRE_TYPES, hxwyszHomeLocation } from './utils'

export default {
    data () {
        return {
            loading: false,
            periodId: null,
            inputPeriodId: '',
            result: null,
            preType: ''
        }
    },
    mounted () {
        this.initLoad()
    },
    methods: {
        formatScore (val) {
            if (val == null || val === '') return '-'
            return Number(val).toLocaleString()
        },
        resolvePreType () {
            const q = this.$route.query.preType
            if (q && ALLOWED_PRE_TYPES.includes(q)) {
                return q
            }
            return this.preType || undefined
        },
        initLoad () {
            const qid = this.$route.query.periodId
            if (qid) {
                this.periodId = Number(qid)
                this.inputPeriodId = String(qid)
                if (this.$route.query.preType) {
                    this.preType = this.$route.query.preType
                }
                this.loading = true
                this.fetchResult().finally(() => { this.loading = false })
                return
            }
            const preType = this.resolvePreType()
            this.loading = true
            getLatestPeriod(preType).then(res => {
                if (res.code === 200 && res.data && res.data.id) {
                    this.periodId = res.data.id
                    this.inputPeriodId = String(res.data.id)
                    if (res.data.preType) {
                        this.preType = res.data.preType
                    }
                    return this.fetchResult()
                }
                return this.tryChampionFallback()
            }).finally(() => { this.loading = false })
        },
        tryChampionFallback () {
            return getChampionTopic(1).then(res => {
                if (res.code === 200 && res.data && res.data.length && res.data[0].periodId) {
                    this.periodId = res.data[0].periodId
                    this.inputPeriodId = String(res.data[0].periodId)
                    if (res.data[0].preType) {
                        this.preType = res.data[0].preType
                    }
                    return this.fetchResult()
                }
            })
        },
        loadByInput () {
            if (!this.inputPeriodId) {
                this.$message.warning('请输入期次 ID')
                return
            }
            this.periodId = Number(this.inputPeriodId)
            this.loading = true
            this.fetchResult().finally(() => { this.loading = false })
        },
        fetchResult () {
            if (!this.periodId) return Promise.resolve()
            return getResult(this.periodId).then(res => {
                if (res.code === 200) {
                    this.result = res.data
                    const entryPreType = (res.data.topThree && res.data.topThree[0] && res.data.topThree[0].preType)
                        || (res.data.topTen && res.data.topTen[0] && res.data.topTen[0].preType)
                    if (entryPreType) {
                        this.preType = entryPreType
                    }
                } else {
                    this.result = null
                    this.$message.error(res.msg || '加载失败')
                }
            }).catch(() => {
                this.result = null
            })
        },
        goBack () {
            this.$router.push(hxwyszHomeLocation(this.preType || this.$route.query.preType))
        },
        goDetail (row) {
            this.$router.push('/hxwysz/detail/' + row.id)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./audition.scss";
</style>
